export default __webpack_public_path__ + "static/media/chaletPiccoloPattern.b592c05e.png";